// imports
import scroll from '../utils/scrollLock';
import isMobile from '../utils/isMobile';

const header = document.getElementById('header');
const mainMenu = header.querySelector('.header__main .menu-items');

const bodyMobileMenuOpen = 'mobile-menu-open';
const menuItemOpen = 'menu-item--open';
const headerDropdownOpen = 'header--dropdown-open';
const headerMobileOpen = 'header--mobile-open';

let onMobile = isMobile();
let dropdownOpen = false;

const closeDropdownMenu = (dropdown) => {
  // remove open class from menu item
  dropdown.parentNode.classList.remove(menuItemOpen);
  // remove dropdown open class from header
  header.classList.remove(headerDropdownOpen);
  // decrease the height
  dropdown.style.height = `0px`;
  // update the open variable
  dropdownOpen = false;
};

const toggleMenuDropdown = () => {
  const linksWithChildren = mainMenu.querySelectorAll(
    '.main__item--has-children > .menu-link',
  );

  linksWithChildren.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();

      const menuItemsOpened = mainMenu.querySelectorAll(
        '.menu-item--open .menu__dropdown',
      );
      if (!onMobile && menuItemsOpened.length) {
        // close all open menu items first (> L only, not clicked one)
        menuItemsOpened.forEach((i) => {
          if (!e.target.parentNode.contains(e.target)) {
            closeDropdownMenu(i);
          }
        });
      }

      const menuItem = e.target.parentNode;
      const headerDropdown = menuItem.querySelector('.menu__dropdown');

      if (menuItem.classList.contains(menuItemOpen) && headerDropdown) {
        closeDropdownMenu(headerDropdown);
      } else {
        menuItem.classList.add(menuItemOpen);

        if (headerDropdown) {
          // add/remove classes to header to change border-radius
          header.classList.add(headerDropdownOpen);
          headerDropdown.style.height = `${headerDropdown.scrollHeight}px`;

          dropdownOpen = true;
        }
      }
    });
  });
};

const closeMobileMenu = () => {
  document.body.classList.remove(bodyMobileMenuOpen);
  header.classList.remove(headerMobileOpen);
  scroll.unlock();
};

const toggleMobileMenu = () => {
  const mobileMenuOpenButton = document.querySelector(
    '.header__mobile-menu-open',
  );

  mobileMenuOpenButton.addEventListener('click', () => {
    const headerDropdown = header.querySelector(
      '.menu-item--open .menu__dropdown',
    );

    if (dropdownOpen) {
      closeMobileMenu();

      if (headerDropdown) {
        closeDropdownMenu(headerDropdown);
      }
    } else {
      document.body.classList.add(bodyMobileMenuOpen);
      header.classList.add(headerMobileOpen);
      scroll.lock();
    }

    dropdownOpen = !dropdownOpen;
  });
};

(() => {
  if (header && mainMenu) {
    toggleMenuDropdown();

    // add mobile click events
    toggleMobileMenu();
  }
})();

if (header) {
  window.addEventListener('click', ({ target }) => {
    const clickedMenuItem = header.querySelector('.menu-item--open');
    const dropdown = header.querySelector('.menu-item--open .menu__dropdown');
    const isCloseButton = target.classList.contains('menu__dropdown-close');

    if (clickedMenuItem && dropdown) {
      const isOutside =
        !clickedMenuItem.contains(target) && !dropdown.contains(target);

      if (dropdownOpen && (isOutside || isCloseButton)) {
        closeDropdownMenu(dropdown);
      }
    }
  });

  // resize listener
  // Todo: throttle this listener.
  window.addEventListener('resize', () => {
    onMobile = isMobile();

    // close menus on resize
    const openDropdown = header.querySelector(
      '.menu-item--open .menu__dropdown',
    );
    // Todo: test all these resize listeners on a real mobile device.
    // Scrolling on XS causes the browser top/bottom bars to minimize
    // or maximize, which triggers a resize event.
    if (openDropdown) {
      closeDropdownMenu(openDropdown);
      closeMobileMenu();
    }
  });

  // close menu on ESC
  window.addEventListener('keydown', ({ key }) => {
    const dropdown = header.querySelector('.menu-item--open .menu__dropdown');
    if (dropdownOpen && key === 'Escape' && dropdown) {
      closeDropdownMenu(dropdown);
    }
  });
}
